import { Database, Eye, Fingerprint, Lock, Mail, ScanSearch, ShieldCheck, Trash2 } from "lucide-react";

const SECTIONS = [
  {
    icon: ScanSearch,
    title: "البيانات التي تجمعها الأداة",
    body: "تعمل أداة «راصد حضوري» داخل متصفحك فقط عند فتحك صفحة سجلات الحضور في منصة حضوري الرسمية وضغطك زر السحب. عندها تقرأ الأداة بيانات الجدول الظاهر أمامك في الصفحة، وتشمل: اسم الموظف، رقم الهوية/السجل، وقت الحضور، وقت الانصراف، وتاريخ السجل. كما تستخدم بريدك الإلكتروني وكلمة مرورك لمنصة راصد حضوري لتسجيل الدخول إلى حسابك فقط.",
  },
  {
    icon: Database,
    title: "كيفية استخدام البيانات",
    body: "تُرسل البيانات المقروءة مباشرة وبتشفير آمن (HTTPS) إلى حسابك أنت فقط في منصة راصد حضوري (rasedhudury.com) لغرض إعداد تقارير الحضور والتأخر والغياب والمساءلات التي تطلبها بنفسك. لا تُستخدم البيانات لأي غرض آخر، ولا تُرسل إلى أي جهة خارجية.",
  },
  {
    icon: ShieldCheck,
    title: "ما لا تجمعه الأداة",
    body: "لا تجمع الأداة سجل تصفحك، ولا محتوى أي صفحة أخرى غير صفحات حضوري التي تفتحها بنفسك، ولا بيانات شخصية خارج جدول الحضور، ولا ملفات تعريف ارتباط لمواقع أخرى. لا تتضمن الأداة أي إعلانات أو تتبع أو تحليلات تسويقية، ولا تُباع بياناتك أو تُشارك مع أي طرف ثالث إطلاقاً.",
  },
  {
    icon: Fingerprint,
    title: "الأذونات المطلوبة ولماذا",
    body: "تطلب الأداة الأذونات التالية لغرض وحيد هو قراءة جدول الحضور وإرساله لحسابك: activeTab وscripting لقراءة الجدول من الصفحة المفتوحة عند طلبك فقط، وstorage لحفظ رمز جلسة الدخول محلياً في متصفحك حتى لا تضطر لتسجيل الدخول في كل مرة، وأذونات الوصول لموقعَي منصة حضوري ومنصة راصد حضوري فقط.",
  },
  {
    icon: Lock,
    title: "التخزين والأمان",
    body: "تُحفظ بيانات الحضور في حسابك على منصة راصد حضوري محميةً بكلمة مرور مشفرة، ويُحفظ رمز الجلسة محلياً في متصفحك عبر chrome.storage ولا يغادر جهازك إلا للمصادقة مع الخادم. جميع الاتصالات مشفرة عبر HTTPS.",
  },
  {
    icon: Trash2,
    title: "حقوقك وحذف البيانات",
    body: "يمكنك في أي وقت حذف سجلات الحضور أو بيانات الموظفين من داخل حسابك في المنصة. إزالة الأداة من المتصفح تحذف جميع بياناتها المحلية فوراً، بما فيها رمز الجلسة. كما يمكنك طلب حذف حسابك بالكامل بالتواصل معنا.",
  },
];

export default function ExtensionPrivacy() {
  return (
    <div className="min-h-screen bg-[#F8FAF9]" data-testid="privacy-page">
      <header className="bg-emerald-950 text-white">
        <div className="max-w-3xl mx-auto px-6 py-10 flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-emerald-900 border border-emerald-800 flex items-center justify-center shrink-0">
            <Eye className="w-6 h-6 text-amber-400" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold" data-testid="privacy-title">
              سياسة الخصوصية — أداة راصد حضوري
            </h1>
            <p className="text-sm text-emerald-200/80 mt-1">
              إضافة متصفح كروم التابعة لمنصة راصد حضوري · آخر تحديث: سبتمبر 2026
            </p>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10 space-y-5">
        <p className="text-sm sm:text-base leading-7 text-slate-600 bg-white border rounded-2xl p-5" data-testid="privacy-intro">
          توضح هذه الصفحة البيانات التي تجمعها إضافة «راصد حضوري» لمتصفح كروم وكيفية استخدامها.
          صُممت الأداة لغرض واحد: مساعدتك على نقل سجلات الحضور من منصة حضوري الرسمية إلى حسابك
          في منصة راصد حضوري بضغطة واحدة، وبأقل قدر ممكن من البيانات.
        </p>

        {SECTIONS.map(({ icon: Icon, title, body }, i) => (
          <section key={i} className="bg-white border rounded-2xl p-5 flex gap-4" data-testid={`privacy-section-${i}`}>
            <div className="w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0">
              <Icon className="w-5 h-5 text-emerald-900" />
            </div>
            <div>
              <h2 className="text-base sm:text-lg font-bold text-emerald-950 mb-1.5">{title}</h2>
              <p className="text-sm leading-7 text-slate-600">{body}</p>
            </div>
          </section>
        ))}

        <section className="bg-emerald-950 text-white rounded-2xl p-5 flex gap-4" data-testid="privacy-contact">
          <div className="w-10 h-10 rounded-xl bg-emerald-900 border border-emerald-800 flex items-center justify-center shrink-0">
            <Mail className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h2 className="text-base sm:text-lg font-bold mb-1.5">تواصل معنا</h2>
            <p className="text-sm leading-7 text-emerald-100/90">
              لأي استفسار حول الخصوصية أو طلب حذف الحساب والبيانات:
              <span dir="ltr" className="inline-block font-semibold text-amber-300">rasedhudury@gmail.com</span>
            </p>
          </div>
        </section>

        <p className="text-center text-xs text-slate-400 pt-2">
          منصة راصد حضوري — نظام تتبع وتقارير الحضور الذكي
        </p>
      </main>
    </div>
  );
}
